// extracted by mini-css-extract-plugin
export default {"container":"z6ifFdMcOvSkR3cMg900","label":"u0oYb4le60g0MBo_nP7e","label-error":"V1W663Wkz2YcEQhQycls","labelRequired":"EW9my76rH0YBzf9uqqXA"};